import { AfterViewInit, Component, ViewChild, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule, IonInput } from '@ionic/angular';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyIonicModule } from '@ngx-formly/ionic';
import { FocusableMixin } from '@ts/shared/form/focus/util-core';
import {
  AutofocusIonicFieldInputProps,
  FormFocusIonInputService,
} from '@ts/shared/form/focus/util-ionic';

@Component({
  selector: 'ts-input-field',
  styleUrls: ['./input-field.component.scss'],
  templateUrl: './input-field.component.html',
  imports: [FormlyIonicModule, IonicModule, ReactiveFormsModule],
})
export class InputFieldComponent
  extends FieldType<FieldTypeConfig<AutofocusIonicFieldInputProps>>
  implements AfterViewInit, FocusableMixin
{
  private formFocusIonInputService = inject(FormFocusIonInputService);

  @ViewChild(IonInput) ionInput!: IonInput;

  setFocus() {
    this.formFocusIonInputService.focus(this.ionInput);
  }

  ngAfterViewInit() {
    this.formFocusIonInputService.setAutofocusIfInProps({
      props: this.props,
      ionInput: this.ionInput,
      formControl: this.formControl,
    });
  }

  // Utility function to make testing easier for classes that needs the ion input.
  getIonInput() {
    return this.ionInput;
  }
}
